import React from 'react';
import SingleSelect from './SingleSelect';

export default React.forwardRef((props, ref) => (
  <SingleSelect ref={ref} {...props} />
));
